import {
  FileSpreadsheet,
} from "lucide-react";
import {
  formatEvaluationAmount,
} from "../../model";
import type { ApprovalRowContext } from "./approval-row-model";
import { ApprovalOfferComparison } from "./ApprovalOfferComparison";

export function ApprovalOfferDecision({ context }: { context: ApprovalRowContext ;}) {
  const {
    request,
    isActionable,
    evaluation,
    systemOffer,
    gmApproval,
    isCompleted,
    displayedOffer,
    displayedDiffersFromSystem,
    selectionLabel,
    selectionOwner,
  } = context;
  return (<>
    {evaluation && displayedOffer ? (
      <div className="approval-decision">
        <div className="approval-decision-heading">
          {displayedDiffersFromSystem &&
            systemOffer ? (
            <div className="approval-selection-compare">
              <article className="is-system">
                <header>
                  <span>Sistem önerisi</span>
                  <small>
                    {systemOffer.rank}. sıra ·{" "}
                    {systemOffer.totalScore !==
                      null
                      ? `${Math.round(systemOffer.totalScore)}/100`
                      : "Puan yok"}
                  </small>
                </header>
                <strong>
                  {systemOffer.supplier}
                </strong>
                <p>{systemOffer.offerNo}</p>
                <dl>
                  <div>
                    <dt>Toplam</dt>
                    <dd>
                      {formatEvaluationAmount(
                        systemOffer.comparableTotal ??
                        systemOffer.enteredTotal ??
                        systemOffer.amount,
                        evaluation.comparisonCurrency,
                      )}
                    </dd>
                  </div>
                  <div>
                    <dt>Teslimat / vade</dt>
                    <dd>
                      {systemOffer.deliveryDays ??
                        "—"}{" "}
                      gün ·{" "}
                      {systemOffer.paymentDays ??
                        "—"}{" "}
                      gün
                    </dd>
                  </div>
                </dl>
              </article>
              <article className="is-human">
                <header>
                  <span>{selectionLabel}</span>
                  <small>
                    {displayedOffer.rank}. sıra ·{" "}
                    {displayedOffer.totalScore !==
                      null
                      ? `${Math.round(displayedOffer.totalScore)}/100`
                      : "Puan yok"}
                  </small>
                </header>
                <strong>
                  {displayedOffer.supplier}
                </strong>
                <p>{displayedOffer.offerNo}</p>
                <dl>
                  <div>
                    <dt>Toplam</dt>
                    <dd>
                      {formatEvaluationAmount(
                        displayedOffer.comparableTotal ??
                        displayedOffer.enteredTotal ??
                        displayedOffer.amount,
                        evaluation.comparisonCurrency,
                      )}
                    </dd>
                  </div>
                  <div>
                    <dt>Teslimat / vade</dt>
                    <dd>
                      {displayedOffer.deliveryDays ??
                        "—"}{" "}
                      gün ·{" "}
                      {displayedOffer.paymentDays ??
                        "—"}{" "}
                      gün
                    </dd>
                  </div>
                </dl>
                <small className="approval-selection-owner">
                  {selectionOwner}
                </small>
              </article>
            </div>
          ) : (
            <div className="approval-selection-summary">
              <div className="approval-selection-summary-topline">
                <span>{selectionLabel}</span>
                <small>
                  {selectionOwner} ·{" "}
                  {request.offers} teklif
                </small>
              </div>
              <div className="approval-selection-summary-title">
                <h3>{displayedOffer.supplier}</h3>
                <span className="approval-alignment">
                  {isCompleted
                    ? "Nihai karar"
                    : evaluation.status ===
                      "SINGLE_OFFER"
                      ? "Tek geçerli teklif"
                      : "Sistemle aynı seçim"}
                </span>
              </div>
              <p>{displayedOffer.offerNo}</p>
            </div>
          )}
        </div>
        <div className="approval-commercial-facts">
          <div>
            <small>Birim fiyat</small>
            <strong>
              {formatEvaluationAmount(
                displayedOffer.unitPrice,
                displayedOffer.currency ??
                evaluation.comparisonCurrency,
              )}{" "}
              /{" "}
              {displayedOffer.unit ??
                request.unit ??
                "birim"}
            </strong>
          </div>
          <div>
            <small>Toplam maliyet</small>
            <strong>
              {formatEvaluationAmount(
                displayedOffer.comparableTotal ??
                displayedOffer.enteredTotal ??
                displayedOffer.amount,
                evaluation.comparisonCurrency,
              )}
            </strong>
          </div>
          <div>
            <small>Teslimat</small>
            <strong>
              {displayedOffer.deliveryDays !==
                null
                ? `${displayedOffer.deliveryDays} gün`
                : "—"}
            </strong>
          </div>
          <div>
            <small>Ödeme vadesi</small>
            <strong>
              {displayedOffer.paymentDays !== null
                ? `${displayedOffer.paymentDays} gün`
                : "—"}
            </strong>
          </div>
          <div>
            <small>Değerlendirme</small>
            <strong>
              {displayedOffer.totalScore !== null
                ? `${Math.round(displayedOffer.totalScore)}/100`
                : "Karşılaştırma yok"}
            </strong>
          </div>
        </div>
        <section
          className="approval-decision-rationale"
          aria-label="Karar gerekçesi"
        >
          <FileSpreadsheet size={18} />
          <div>
            <strong>
              {isCompleted &&
                gmApproval?.decisionNote
                ? "Nihai karar gerekçesi"
                : displayedDiffersFromSystem
                  ? "Seçim gerekçesi"
                  : "Değerlendirme özeti"}
            </strong>
            <p>
              {isCompleted &&
                gmApproval?.decisionNote
                ? gmApproval.decisionNote
                : displayedDiffersFromSystem
                  ? evaluation.recommendation
                    ?.rationale
                  : (evaluation.explanation ??
                    evaluation.recommendation
                      ?.rationale)}
            </p>
            {systemOffer &&
              displayedDiffersFromSystem ? (
              <span>
                Sistem önerisi:{" "}
                {systemOffer.supplier}
              </span>
            ) : null}
          </div>
        </section>
        <ApprovalOfferComparison context={context} />
      </div>
    ) : (
      <div className="approval-decision is-missing">
        <strong>
          {isActionable
            ? "Dosya eksik yönlendirilmiş"
            : "Ticari değerlendirme kaydı bulunmuyor"}
        </strong>
        <p>
          {isActionable
            ? "Teklif seçimi, ticari koşullar ve uzman gerekçesi Satın Alma Uzmanı tarafından tamamlanmalıdır. Müdür bu alanları doldurmaz; dosyayı açık görevle uzmanın çalışma kuyruğuna geri gönderir."
            : "Bu kayıt yalnızca süreç takibi amacıyla gösteriliyor; mevcut aşamada sizden bir işlem beklenmiyor."}
        </p>
      </div>
    )}
  </>);
}
